var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/victory-zoom-container/~/lodash/_coreJsData.js
// module id = ./node_modules/victory-zoom-container/node_modules/lodash/_coreJsData.js
// module chunks = 1